import { Reveal, SectionHead } from "@/components/common/Reveal";
import { CtaLink } from "@/components/common/Cta";
import { ProjectCard } from "@/components/projects/ProjectCard";
import { PROJECTS } from "@/data/site";

const FEATURED = ["stocking-south", "abbey-road", "hazelbrook", "sandymount"];

export const ProjectsStrip = () => (
  <section className="relative" data-testid="home-projects">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead label="Section 03 — Selected schemes" title="Built with Dublin's developers" text="Houses, duplexes and apartment blocks fitted out alongside the main contractor, from first fix to commissioning." />
        <CtaLink to="/projects" variant="outline" testid="home-all-projects-btn">All 14 projects</CtaLink>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-4">
        {FEATURED.map((slug, i) => {
          const p = PROJECTS.find((x) => x.slug === slug);
          return (
            <Reveal key={slug} delay={i * 0.08}>
              <ProjectCard project={p} />
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
